var React = require('react');

function Reload (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.438 4.657a1.015 1.015 0 0 1-.049-.046 5.5 5.5 0 1 0 0 7.778 1 1 0 0 1 1.414 1.414 7.5 7.5 0 1 1-.346-10.932V1.414a1 1 0 1 1 2 0v4.243a1 1 0 0 1-1 1H9.214a1 1 0 1 1 0-2h2.224z","fill":"#424242"}));
}

Reload.defaultProps = {"width":"15","height":"16","viewBox":"0 0 15 16"};

module.exports = Reload;

Reload.default = Reload;
